import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { PageCardheadComponent } from './pageheader-card.component';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    PageCardheadComponent
  ],
  exports:[PageCardheadComponent]
})
export class PageheaderCardModule { }
